<div class="container animated fadeIn">
    <img src="https://static.monific.com/assets/assets-app/img/icon/img/undraw_mailbox_re_dvds.svg" alt="">
    <h3>¿Seguro que quieres darte de baja de nuestros mensajes?</h3>
    <p>Dejarás de recibir los mensajes que enviamos</p>
    <div class="d-sm-flex justify-content-around d-block m-auto">
        <button mat-button (click)="cancelSubscription()">Sí, darme de baja</button>
        <button mat-button (click)="cancel()" class="invert mt-3 mt-sm-0">Cancelar</button>
    </div>
</div>